import type { ButtonProps } from '@common/components';
import { Button } from '@common/components';
import { cn } from '@core/utils';

export interface FooterButtonProps extends ButtonProps {
  shape?: ButtonProps['roundness'];
}

export const ButtonFooter = ({
  className,
  style,
  shape,
  ...restButtonProps
}: FooterButtonProps) => {
  return (
    <footer
      className={cn(
        'sticky bottom-0 mt-auto box-border border-t border-Gray-300 bg-Gray-white p-20',
        className,
      )}
      style={style}
    >
      <Button {...restButtonProps} className="w-full" roundness={shape} />
    </footer>
  );
};
